var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import PaymentForm from './PaymentForm.vue';
import state from '../../State';
import { paymentViewToPayment, getDefaultPaymentView, clonePayment } from './Payments.vue';
let AddPayment = class AddPayment extends Vue {
    constructor() {
        super(...arguments);
        this.dialog = false;
        this.invalid = false;
        this.payment = getDefaultPaymentView();
        this.form = null; // eslint-ignore-line
    }
    onForm(form) {
        this.form = form;
    }
    save() {
        const valid = this.form.validate();
        if (!valid) {
            this.invalid = true;
            setTimeout(() => {
                this.invalid = false;
            }, 3000);
            return;
        }
        const payment = paymentViewToPayment(this.payment);
        void fetch(state.get('request.url.payments'), Object.assign(Object.assign({}, state.get('request.params.api.post')), { body: JSON.stringify(payment) }))
            .then(res => res.json())
            .then(data => {
            if (data.ok) {
                this.dialog = false;
                this.payment = getDefaultPaymentView();
                this.$emit('add', clonePayment(data.payment));
            }
            else {
                this.$emit('message', {
                    message: data.message,
                    icon: 'las la-bug',
                    color: 'red'
                });
            }
        });
    }
    close() {
        this.form.reset();
        this.dialog = false;
    }
};
AddPayment = __decorate([
    Component({
        name: 'AddPayment',
        components: { PaymentForm }
    })
], AddPayment);
export default AddPayment;
